@for(evento of eventos; track $index) { @if($index < 2) {
<p
  style="background: {{ evento.color }}"
  class="pl-1 rounded-md mb-1 text-white lg:text-sm md:text-sm sm:text-xs text-xs truncate"
>
  <small>
    {{ evento.nombre }}
  </small>
</p>
} } @if(eventos.length > 2) {
<p
  class="pl-1 rounded-md mb-2 lg:text-sm md:text-sm sm:text-xs text-xs truncate"
>
  <small>+ {{ eventos.length - 2 }} eventos más</small>
</p>
}
